export class ChangePasswordModel {      
    username: string;
    oldpassword: string;
    Newpassword: string;
    ConfirmPassword: string;
    isActive: boolean;
    status: boolean;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/Model/login/changepasswordmodel.ts